import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-liveproduct",
  "use": "icon-liveproduct-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-liveproduct\"><defs><style type=\"text/css\"></style></defs><path d=\"M128 64h384v384H64V128a64 64 0 0 1 64-64z m640 384a192 192 0 1 1 0-384 192 192 0 0 1 0 384zM64 512h896v384a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64V512z\" fill=\"#dbdbdb\" p-id=\"4006\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/liveproduct.svg
// module id = zOj1
// module chunks = 4